var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoveTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1315_668)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29764 3.99988L0.287559 12.0101C0.102145 12.1954 -8.06437e-08 12.4427 -6.91167e-08 12.7064C-5.75898e-08 12.9701 0.102145 13.2174 0.287559 13.4027L0.87731 13.9926C1.2616 14.3764 1.88618 14.3764 2.26988 13.9926L8.99627 7.26619L15.7301 14C15.9155 14.1853 16.1627 14.2876 16.4263 14.2876C16.6901 14.2876 16.9373 14.1853 17.1228 14L17.7124 13.4101C17.8979 13.2247 18 12.9776 18 12.7139C18 12.4501 17.8979 12.2028 17.7124 12.0176L9.69504 3.99988C9.50904 3.81417 9.2607 3.71217 8.99671 3.71276C8.73168 3.71217 8.48349 3.81417 8.29764 3.99988Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1315_668"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 18) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoveTop);
export default __webpack_public_path__ + "static/media/move-top.a538d6a00aa1f6432caddfe6756736cd.svg";
export { ForwardRef as ReactComponent };